<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Presupuestos</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        <v-container flex grid-list-sm>
                            <v-layout wrap align-center justify-center>
                                <v-flex class="text-xs-center">
                                    <v-btn color="green" dark @click.native="mostrarSheet" v-if="mostrar === 'i'">
                                        <v-icon>refresh</v-icon>
                                        Cambiar Estado
                                    </v-btn>
                                    <v-btn color="orange" dark @click.native="filtroDiag = true">
                                        <v-icon>filter_list</v-icon>
                                        Filtros
                                    </v-btn>
                                </v-flex>
                                <v-flex>
                                    <v-checkbox label="¿Avatar?" v-model="mostrarAvatar"></v-checkbox>
                                </v-flex>
                                <v-flex class="text-xs-center">
                                    <v-text-field @keyup.enter.native="tabla()" v-model="search" label="Búsqueda" clearable prepend-icon="search"></v-text-field>
                                </v-flex>
                                <v-flex class="text-xs-center">
                                    <v-select :items="mostrarLista" v-model="mostrar" label="Mostrando" @input="tabla"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            :select-all="mostrar === 'i'"
                            item-key="id"
                            v-model="seleccionado"
                            class="tabla-compacta-col"
                    >
                        <template slot="items" slot-scope="props">
                            <tr @click="(mostrar === 'i')?props.selected = !props.selected : ''"
                                @dblclick="props.expanded = !props.expanded">
                                <td class="text-xs-center" v-if="(mostrar === 'i')">
                                    <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'i'">
                                    <v-tooltip top v-if="props.item.estado">
                                        <v-icon slot="activator" :color="props.item.estado.color">{{ props.item.estado.icono }}</v-icon>
                                        <span>{{ props.item.estado.desig }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-center">
                                    <router-link exact :to="'/presupuesto/' + props.item.presupuesto_id">{{ props.item.presupuesto_id }}</router-link>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'i' && props.item.item_tipo">
                                    <v-layout>
                                        <v-flex>
                                            <router-link exact :to="'/presupuesto/' + props.item.presupuesto_id + '/'+ props.item.item_tipo.cod +'/edit/' + props.item.id">{{ props.item.id }}
                                            </router-link>
                                        </v-flex>
                                        <v-flex>
                                            <v-layout>
                                                <v-flex>
                                                    <v-tooltip fixed top>
                                                        <v-icon slot="activator" small v-if="props.item.obs && props.item.obs.length > 0" color="pink">chat_bubble</v-icon>
                                                        <span>{{ props.item.obs }}</span>
                                                    </v-tooltip>
                                                </v-flex>
                                                <v-flex>
                                                    <v-tooltip fixed top>
                                                        <v-icon slot="activator" small v-if="props.item.segunda" color="light-green accent-3">emoji_emotions</v-icon>
                                                        <span>SEGUNDA</span>
                                                    </v-tooltip>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'i'">
                                    <v-avatar :size="30" v-if="props.item.empresa && props.item.empresa.avatar">
                                        <img :src="props.item.empresa.avatar" alt="avatar">
                                    </v-avatar>
                                </td>
                                <td class="text-xs-right">{{ props.item.rzon_soc }}</td>
                                <td class="text-xs-right">{{ props.item.created_at }}</td>
                                <td class="text-xs-right" v-if="mostrar === 'i'">
                                    <span v-if="props.item.item">
                                        <b>{{ (props.item.item_tipo)?props.item.item_tipo.desig: ''}}</b><br>
                                        ({{ props.item.item.micro_id_1 }}) {{ props.item.item.descripcion}}
                                    </span>
                                    <b v-else>{{ (props.item.item_tipo)? props.item.item_tipo.desig : ''}}</b><br>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'p'">
                                    <v-tooltip v-if="props.item.usersAvatar" fixed top>
                                        <v-avatar size="30" v-if="props.item.usersAvatar" slot="activator">
                                            <img :src="props.item.usersAvatar" alt="avatar">
                                        </v-avatar>
                                        <span>{{ props.item.user }}</span>
                                    </v-tooltip>
                                    <v-tooltip fixed top v-if="!props.item.usersAvatar && props.item.user && showAvatar">
                                        <v-avatar size="30" :color="props.item.user | strToColor " slot="activator">
                                            <span class="white--text">{{ props.item.user | iniciales}}</span>
                                        </v-avatar>
                                        <span>{{ props.item.user }}</span>
                                    </v-tooltip>
                                    <span v-if="!props.item.usersAvatar && !showAvatar">{{ props.item.user }}</span>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'p'">
                                    <v-tooltip v-if="props.item.vendedorAvatar" fixed top>
                                        <v-avatar size="30" v-if="props.item.vendedorAvatar" slot="activator">
                                            <img :src="props.item.vendedorAvatar" alt="trevor">
                                        </v-avatar>
                                        <span>{{ props.item.vendedor }}</span>
                                    </v-tooltip>
                                    <v-tooltip fixed top v-if="!props.item.vendedorAvatar && props.item.vendedor && showAvatar">
                                        <v-avatar size="30" :color="props.item.vendedor | strToColor " slot="activator">
                                            <span class="white--text">{{ props.item.vendedor | iniciales}}</span>
                                        </v-avatar>
                                        <span>{{ props.item.vendedor }}</span>
                                    </v-tooltip>
                                    <span v-if="!props.item.vendedorAvatar && !showAvatar">{{ props.item.vendedor }}</span>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'p'">
                                    <v-tooltip v-if="props.item.distribuidorAvatar" fixed top>
                                        <v-avatar size="30" slot="activator">
                                            <img :src="props.item.distribuidorAvatar" alt="trevor">
                                        </v-avatar>
                                        <span>{{ props.item.distribuidor }}</span>
                                    </v-tooltip>
                                    <v-tooltip fixed top v-if="!props.item.distribuidorAvatar && props.item.distribuidor && showAvatar">
                                        <v-avatar size="30" :color="props.item.distribuidor | strToColor " slot="activator">
                                            <span class="white--text">{{ props.item.distribuidor | iniciales}}</span>
                                        </v-avatar>
                                        <span>{{ props.item.distribuidor }}</span>
                                    </v-tooltip>
                                    <span v-if="!props.item.distribuidorAvatar && !showAvatar">{{ props.item.distribuidor }}</span>
                                </td>
                                <td class="text-xs-right">
                                    <div v-if="mostrar === 'p'">
                                        <span>{{props.item.total | moneda(props.item.moneda_id)}}</span><br>
                                        <span class="bold-text" v-if="props.item.totalB && props.item.totalB > 0">{{props.item.totalB | moneda(props.item.moneda_id)}}</span>
                                    </div>
                                    <span v-else>{{ props.item.valor | moneda(props.item.moneda_id) }}</span>
                                </td>
                                <td class="text-xs-center" v-if="mostrar === 'p'">
                                    <v-icon v-if="props.item.progreso && props.item.progreso === 100" color="green">check</v-icon>
                                    <presup-progreso v-else rotate="-90" :porcentaje="(props.item.progreso)? props.item.progreso : 0"></presup-progreso>
                                </td>
                                <!--OPERACIONES-->
                                <td class="text-xs-center">
                                    <v-menu left>
                                        <v-btn color="primary" flat dark icon small slot="activator">
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                        <v-list dense>
                                            <v-list-tile :to="'/presupuesto/' + props.item.presupuesto_id">
                                                <v-list-tile-action>
                                                    <v-icon color="green">remove_red_eye</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Ver Presupuesto</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile :to="'/presupuesto/edit/' + props.item.presupuesto_id">
                                                <v-list-tile-action>
                                                    <v-icon color="blue">edit</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Editar Presupuesto</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile @click="pdfAbre2(props.item.presupuesto_id)">
                                                <v-list-tile-action>
                                                    <v-icon color="pink">print</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Imprime presupuesto</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile @click="pdfAbre(props.item.presupuesto_id)">
                                                <v-list-tile-action>
                                                    <v-icon color="orange">print</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Imprime presupuesto viejo</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile :to="'/presupuesto/'+ props.item.presupuesto_id +'/ingenieria/' + props.item.id" v-if="mostrar === 'i'">
                                                <v-list-tile-action>
                                                    <v-icon color="orange">history</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Ingenieria</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile @click="copiarDialogShow(props.item.presupuesto_id)">
                                                <v-list-tile-action>
                                                    <v-icon color="brown">content_copy</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-title>Copiar Presupuesto</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                            <v-card flat>
                                <v-card-text v-if="mostrar === 'i' && props.item.item_tipo.cod === 'pan'">
                                    <v-list dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title><b>Cantidad de piezas:</b> {{ props.item.cant_pza }} un</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title><b>Ancho:</b> {{ props.item.ancho }} m</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title><b>Largo de piezas:</b> {{ props.item.largo_pza }} m</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-title><b>Precio Unitario:</b> {{ props.item.pu | moneda(props.item.moneda) }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-data-table>
                </v-card>
                <!--    SHEET///////////////////////////////////////////////////////////////////////////-->
                <v-bottom-sheet v-model="sheet">
                    <v-card tile>
                        <v-progress-linear indeterminate :active="cambiando" height="3" class="my-0"></v-progress-linear>
                        <v-list>
                            <v-subheader>Cambio de estado</v-subheader>
                            <template v-for="e in estados">
                                <v-list-tile @click="verificaCambioEstado(e.id)">
                                    <v-list-tile-action>
                                        <v-icon :color="e.color">{{ e.icono }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-title>{{ e.desig }}</v-list-tile-title>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-card>
                </v-bottom-sheet>
                <!--    FILTRO///////////////////////////////////////////////////////////////////////////-->
                <v-dialog v-model="filtroDiag" max-width="900" scrollable>
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>Filtros</v-card-title>
                        <v-card-text>
                            <v-select dense clearable hide-selected label="Por estado" v-model="f.estado" :items="estados" multiple chips item-text="desig" item-value="id">
                                <template slot="selection" slot-scope="data">
                                    <v-chip close @input="data.parent.selectItem(data.item)"
                                            :selected="data.selected" class="chip--select-multi" :key="JSON.stringify(data.item)">
                                        <v-avatar>
                                            <v-icon :color="data.item.color">{{ data.item.icono }}</v-icon>
                                        </v-avatar>
                                        {{ data.item.desig }}
                                    </v-chip>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template>
                                        <v-list-tile-action>
                                            <v-icon :color="data.item.color">{{ data.item.icono }}</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title v-html="data.item.desig"></v-list-tile-title>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-select>
                            <v-autocomplete dense clearable label="Por Tipo" item-value="id" item-text="desig" v-model="f.tipoItem" :items="tipoItems" multiple chips></v-autocomplete>
                            <v-autocomplete dense clearable label="Por Usuario" item-value="id" item-text="name" v-model="f.usuario" :items="usuarios" multiple chips></v-autocomplete>
                            <v-autocomplete dense clearable label="Por Vendedor" item-value="id" item-text="name" v-model="f.vendedor" :items="usuarios" multiple chips></v-autocomplete>
                            <v-autocomplete dense clearable label="Por Distribuidor" item-value="id" item-text="name" v-model="f.distribuidor" :items="usuarios" multiple chips></v-autocomplete>
                            <empresa-select v-model="f.empresa"></empresa-select>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" flat="flat" @click.native="filtroDiag = false">Cancelar</v-btn>
                            <v-btn color="green darken-1" flat="flat" @click.native="tabla(); filtroDiag = false">Filtrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--    OBSERVACIONES///////////////////////////////////////////////////////////////////////////-->
                <v-dialog v-model="observacionDiag" max-width="500px">
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>Ingrese observación</v-card-title>
                        <v-card-text>
                            <v-textarea v-model="observacion"></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" flat @click="observacionDiag=false">Cancelar</v-btn>
                            <v-btn color="green darken-1" flat @click="cambiaEstado(estadoSeleccionado)">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <!--    COPIAS///////////////////////////////////////////////////////////////////////////-->
                <v-dialog v-model="copiarDiag" max-width="500px" persistent>
                    <v-card>
                        <v-card-title class="headline grey lighten-2" primary-title>Copia de presupuesto</v-card-title>
                        <v-card-text>
                            <v-select label="Tipo de copia" v-model="copia.oper" :items="copiaOper"></v-select>
                            <v-text-field label="Cantidad" v-model="copia.cant"></v-text-field>
                            <v-text-field v-if="copia.oper === 'adicionar'" label="Presupuesto" v-model="copia.presupAdicionar"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" flat @click="copiarDiag=false">Cancelar</v-btn>
                            <v-btn color="green darken-1" flat @click="copiarPresupuesto()">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinPresup from '../../mixins/presupuesto';
    import mixinPresupItem from '../../mixins/presupuestoItems';
    import mixinItems from '../../mixins/items';
    import mixinUsers from '../../mixins/auth/users';
    import mixinConfig from '../../mixins/config';
    import moneda from '../../filters/moneda';
    import iniciales from '../../filters/iniciales';
    import strToColor from '../../filters/strToColor';
    import {mapActions, mapGetters} from 'vuex';
    import PresupProgreso from '../../components/PresupProgreso';
    import empresaSelect from '../../components/EmpresaSelect';
    import doHarlem from '../../test/harlem'
    import voltear from "../../test/voltear";

    export default {
        name: "list",
        mixins: [mixinPresup, mixinPresupItem, mixinUsers, mixinItems, mixinConfig],
        components: {PresupProgreso, empresaSelect},
        filters: {moneda, iniciales, strToColor},
        data() {
            return {
                cambiando: false,
                filtroDiag: false,
                copiarDiag: false,
                loading: false,
                mostrar: (this.$ls.get('presup.list.mostrar')) ? this.$ls.get('presup.list.mostrar') : 'i',
                mostrarLista: [
                    {text: 'ITEMS', value: 'i'},
                    {text: 'PRESUPUESTOS', value: 'p'},
                ],
                headersPresup: [
                    {text: 'Presupuesto', value: 'presupuesto_id', align: 'center'},
                    {text: 'Cliente', value: 'rzon_soc', align: 'center'},
                    {text: 'Fecha de Ingreso', value: 'presupuestos.created_at', align: 'center'},
                    {text: 'Usuario', value: 'users.name', align: 'center'},
                    {text: 'Vendedor', value: 'vendedor.name', align: 'center'},
                    {text: 'Distribuidor', value: 'distribuidor.name', align: 'center'},
                    {text: 'Total', value: 'subtotal', align: 'center'},
                    {text: 'Progreso', value: 'progreso', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                headersItems: [
                    {text: 'Estado', value: 'estado_id', align: 'center'},
                    {text: 'Presupuesto', value: 'presupuesto_id', align: 'center'},
                    {text: 'Item', value: 'presupuesto_items.id', align: 'center'},
                    {text: 'Empresa', value: 'empresa_id', align: 'center'},
                    {text: 'Cliente', value: 'rzon_soc', align: 'center'},
                    {text: 'Fecha de Ingreso', value: 'presupuestos.created_at', align: 'center'},
                    {text: 'Item', value: 'item_id', align: 'center'},
                    {text: 'Valor', value: 'subtotal', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                headers: [],
                items: [],
                search: '',
                totalItems: 0,
                cols: [],
                pag: {
                    sortBy: (this.mostrar === 'id') ? 'presupuesto_items.id' : 'presupuesto_id',
                    descending: true
                },
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                seleccionado: [],
                estados: [],
                tipoItems: [],
                usuarios: [],
                sheet: false,
                f: {estado: [], tipoItem: [], usuario: [], vendedor: [], distribuidor: [], empresa: ''},
                observacion: '',
                observacionDiag: false,
                estadoObs: [],
                estadoSeleccionado: '',
                copia: {
                    oper: 'total',
                    cant: 0,
                    presupuesto_id: '',
                    presupAdicionar: ''
                },
                copiaOper: [
                    {value: 'total', text: 'Total'},
                    {value: 'multiplica', text: 'Multiplica'},
                    {value: 'adicionar', text: 'Adicionar a presupuesto'},
                ]
            }
        },
        computed: {
            ...mapGetters('config', ['showAvatar']),
            ...mapGetters('auth', ['userName']),
            mostrarAvatar: {
                get() {
                    return this.showAvatar;
                },
                set() {
                    this.toggleShowAvatar();
                }
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true,
                immediate: false
            }
        },
        mounted() {
            this.getEstados();
            this.getTipos();
            this.getUsuarios();
            this.tabla();
            //obtengo configuracion sobre estados que se observarn
            this.configGet('estadoObs', r => {
                this.estadoObs = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            ...mapActions('config', ['toggleShowAvatar']),
            copiarDialogShow(id) {
                this.copiarDiag = true;
                this.copia.presupuesto_id = id;
            },
            copiarPresupuesto() {
                this.loading = true;
                this.presupuestoCopia(this.copia, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.copiarDiag = false;
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al copiar registros', tipo: 'error'});
                    this.loading = false;
                })
            },
            verificaCambioEstado(estado) {
                this.estadoSeleccionado = estado;
                if (this.estadoObs.includes(estado)) {
                    this.observacionDiag = true;
                } else {
                    this.cambiaEstado(estado);
                }
            },
            cambiaEstado(estado) {
                this.observacionDiag = false;
                this.cambiando = true;
                let items = [];
                this.seleccionado.forEach(i => {
                    items.push(i.id);
                });
                this.presupuestoItemCambiaEstado({estado: estado, items: items, obs: this.observacion},
                    r => {
                        this.tabla();
                        this.msjShow(r);
                        this.cambiando = false;
                        this.sheet = false;
                        this.seleccionado = [];
                    }, err => {
                        console.log(err);
                        this.cambiando = false;
                    })
            },
            mostrarSheet() {
                if (this.seleccionado.length === 0) {
                    this.msjShow({txt: 'Debe seleccionar al menos un item', tipo: 'error'})
                } else {
                    this.sheet = true;
                }
            },
            getUsuarios() {
                this.usersList(r => {
                    this.usuarios = r;
                }, err => {
                    console.log(err)
                })
            },
            getTipos() {
                this.itemTipos(r => {
                    this.tipoItems = r;
                }, err => {
                    console.log(err)
                })
            },
            getEstados() {
                this.estadosListado(r => {
                    this.estados = r;
                }, err => {
                    console.log(err)
                })
            },
            tabla() {
                if (this.search === 'terrorista') {
                    doHarlem();
                    this.search = '';
                }
                // if (this.search && this.userName === 'Martin Aristarain') {
                //     voltear().run();
                // }
                this.loading = true;
                this.$ls.set('presup.list.mostrar', this.mostrar)
                this.pag.search = this.search;
                let url = 'presupuesto/item?page=';
                if (this.mostrar === 'i') {
                    this.headers = this.headersItems;
                    url = 'presupuesto/item?page=';
                } else {
                    this.headers = this.headersPresup;
                    url = 'presupuesto?page=';
                }
                if (this.f) {
                    for (let key in this.f) {
                        this.pag[key] = this.f[key]
                    }
                }
                this.$http.get(url + this.pag.page, {params: this.pag})
                    .then(r => {
                        this.items = r.data.data;
                        this.totalItems = r.data.total;
                        this.loading = false
                    }, err => {
                        console.log(err);
                        this.loading = false
                    })
            },
            pdfAbre(presupuesto_id) {
                window.open(window.Laravel.urlBase + '/presupuesto/pdf?presup=' + presupuesto_id, '_blank');
            },
            pdfAbre2(presupuesto_id) {
                window.open(window.Laravel.urlBase + '/presupuesto/pdf/' + presupuesto_id, '_blank');
            },
        }

    }
</script>
<style scoped>
    .bold-text {
        font-weight: bolder;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/list.vue